import { render, staticRenderFns } from "./index.vue?vue&type=template&id=4535a956&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=4535a956&prod&lang=scss&scoped=true"
import style1 from "./index.vue?vue&type=style&index=1&id=4535a956&prod&scoped=true&lang=css"
import style2 from "./index.vue?vue&type=style&index=2&id=4535a956&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4535a956",
  null
  
)

export default component.exports